import React from "react";
import { changeParameter } from "../../../api_calls/TableauVisuals";
import { Box } from "@mui/material";
import SelectBox from "../Selectors/SelectBox";
import SingleSelect from "../Selectors/SingleSelect";
import { updateStateData } from "../../../Store/actions";
import { useDispatch, useSelector } from "react-redux";

const impressionFormatOptions = [
    {
        value: false,
        label: "Impressions Share (%)"
    },
    {
        value: true,
        label: "Absolute Impressions"
    }
];

const ImpressionFormat = ({ reduxKeywordToSaveValue, redux_param_name }) => {
    const userStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();
    const [impressionFormatSelection, setImpressionFormatSelection] = React.useState({});
    const [dataLoaded, setDataLoaded] = React.useState(false);

    React.useEffect(() => {
        // sort options based on label in ascending order
         const selectedVal = typeof userStateData[reduxKeywordToSaveValue] !== "undefined" && typeof userStateData[reduxKeywordToSaveValue][redux_param_name] !== "undefined" ?
            impressionFormatOptions.filter(opt => opt.value === userStateData[reduxKeywordToSaveValue][redux_param_name])[0]
            : impressionFormatOptions[0]
        setImpressionFormatSelection(selectedVal);

        setTimeout(() => {
            setDataLoaded(true);
        }, 1000);
    }, []);

    return dataLoaded ? (
        <Box sx={{ width: 220 }}>
            <SingleSelect
                enableFullWidth={true}
                label={"Impressions Format"}
                disableSearch={true}
                sortOptions={false}
                selectionCheck={(option, value) => option.label === value.label}
                options={impressionFormatOptions}
                defaultVal={impressionFormatSelection}
                onChangeCall={(selectedOption) => {
                    setImpressionFormatSelection(selectedOption);
                    dispatchAction(
                        updateStateData({
                            [reduxKeywordToSaveValue]: {
                                ...userStateData[reduxKeywordToSaveValue],
                                [redux_param_name]: selectedOption.value,
                            },
                        })
                    );
                }}
            />
        </Box>
    ) : (
        <></>
    );
};

export default ImpressionFormat;

